module.exports = ".form-group {\r\n\t/*margin-bottom: 1.75rem;*/\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/business/business-profile/business-profile-create.component.css
// module id = ./src/app/components/business/business-profile/business-profile-create.component.css
// module chunks = main